"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactScroll = require("react-scroll");

var _reactRedux = require("react-redux");

var _sideNavigation = _interopRequireDefault(require("../styles/side-navigation.css"));

var SideNavigation = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(SideNavigation, _React$Component);

  function SideNavigation() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SideNavigation.prototype;

  _proto.renderDash = function renderDash(section, idx) {
    var theme = this.props.theme;
    return /*#__PURE__*/_react["default"].createElement(_reactScroll.Link, {
      to: section.id,
      key: idx,
      className: "" + _sideNavigation["default"].trackingDash,
      activeClass: "" + _sideNavigation["default"].isActive,
      spy: true,
      smooth: true,
      duration: 500
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _sideNavigation["default"].dashLabel + " " + theme.mmcMedium
    }, section.label));
  };

  _proto.renderDashes = function renderDashes() {
    var _this = this;

    var sections = this.props.sections;
    var dashes;

    if (sections && sections.length > 0) {
      dashes = sections.map(function (section, idx) {
        return _this.renderDash(section, idx);
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dashes);
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _sideNavigation["default"].container
    }, this.renderDashes());
  };

  return SideNavigation;
}(_react["default"].Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    sections: state.sideNavData.sections
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(SideNavigation);

exports["default"] = _default;
SideNavigation.displayName = 'SideNavigation';
SideNavigation.defaultProps = {};